<template>
  <article
    class="card roomy margin-bottom-2xl"
    style="--card-background: transparent"
  >
    <font-awesome-icon
      :icon="$v6.duotone.faFaceConfused"
      size="4x"
      style="--fa-secondary-opacity: 1; --fa-primary-color: var(--fa-navy); --fa-secondary-color: var(--fa-yellow)"
    />
    <h1 class="margin-y-2xs">Jinkies!</h1>

    <p class="size-lg laptop:column-8 laptop:offset-2">
      We don't have any Free {{ titleCase(selectedFamily) }} {{ titleCase(selectedStyle) }} icons in {{ categoryLabel }}. But below are the icons you get with
      Font Awesome Pro.
    </p>
    <site-link
      to="/plans"
      class="button yellow"
    >
      <font-awesome-icon
        :icon="$v6.regular.faRocketLaunch"
        class="margin-right-md"
        size="lg"
      />
      Get Font Awesome Pro
    </site-link>

    <p class="margin-top-2xl">
      &hellip;or you can
      <site-link :to="$search({ free: true })">view all our Free icons</site-link>.
    </p>
  </article>
</template>

<script>
  import startCase from 'lodash/startCase'

  export default {
    name: 'CategoryNoResults',

    props: {
      categoryLabel: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      selectedFamily: {
        type: String
      }
    },

    methods: {
      titleCase(value) {
        return startCase(value)
      }
    }
  }
</script>
